import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterRangeSearchValueObject} from './FilterRangeSearchValueObject.js'

export class FilterElectricChargingTimeFastModeSearchValueObject extends ValueObject {
  #chargingTimeFastMode

  constructor({chargingTimeFastMode}) {
    super()
    this.#chargingTimeFastMode = chargingTimeFastMode
  }

  static create({chargingTimeFastMode}) {
    return new FilterElectricChargingTimeFastModeSearchValueObject({
      chargingTimeFastMode: FilterRangeSearchValueObject.create(chargingTimeFastMode)
    })
  }

  static createWithDefaultValue({config, chargingTimeFastMode}) {
    const {DEFAULT_ELECTRIC_CHARGING_TIME_FAST_MODE_SEARCH} = config.get('searchFilters')

    return new FilterElectricChargingTimeFastModeSearchValueObject({
      chargingTimeFastMode: FilterRangeSearchValueObject.create({
        from: chargingTimeFastMode?.from || DEFAULT_ELECTRIC_CHARGING_TIME_FAST_MODE_SEARCH.from,
        to: chargingTimeFastMode?.to || DEFAULT_ELECTRIC_CHARGING_TIME_FAST_MODE_SEARCH.to
      })
    })
  }

  static createQueryParams({config, chargingTimeFastMode}) {
    const {DEFAULT_ELECTRIC_CHARGING_TIME_FAST_MODE_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} =
      config.get('searchFilters')

    return new FilterElectricChargingTimeFastModeSearchValueObject({
      chargingTimeFastMode: {
        from: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE].from,
          value: chargingTimeFastMode?.from || DEFAULT_ELECTRIC_CHARGING_TIME_FAST_MODE_SEARCH.from
        }),
        to: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE].to,
          value: chargingTimeFastMode?.to || DEFAULT_ELECTRIC_CHARGING_TIME_FAST_MODE_SEARCH.to
        })
      }
    })
  }

  get isEmpty() {
    return this.#chargingTimeFastMode.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.#chargingTimeFastMode.from.isEmpty && {
        ...this.#chargingTimeFastMode.from.queryParam
      }),
      ...(!this.#chargingTimeFastMode.to.isEmpty && {
        ...this.#chargingTimeFastMode.to.queryParam
      })
    }
  }

  get value() {
    return this.#chargingTimeFastMode.value
  }

  toJSON() {
    return {
      chargingTimeFastMode: this.#chargingTimeFastMode.toJSON()
    }
  }
}
